import * as types from 'constants/ActionTypes';

const defaultState = {
  active: null,
};

/**
 * lodgingCheckboxSession reducer.
 * Persists Mobility lodging-checkbox state from the search entry URL for Mixpanel purchase events.
 *
 * @param {object} state - Current state.
 * @param {object} action - Dispatched action.
 * @returns {object} Next state.
 */
export default function lodgingCheckboxSession(state = defaultState, action) {
  switch (action.type) {
    case types.SET_LODGING_CHECKBOX_SESSION:
      return {
        ...state,
        active: action.active,
      };

    case types.RESET_SEARCH:
    case types.RESET_LODGING_CHECKBOX_SESSION:
      return defaultState;

    default:
      return state;
  }
}
